"use strict";

exports.__esModule = true;
exports["default"] = SocialLinkedin;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SocialLinkedin(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M485.5 1h-459C12.4 1 1 12.4 1 26.5v459C1 499.6 12.4 511 26.5 511h459c14.1 0 25.5-11.4 25.5-25.5v-459C511 12.4 499.6 1 485.5 1zM160.3 436.5H82.6V188.9h77.7v247.6zm-38.9-270.2c-26.8 0-48.6-21.8-48.6-48.6s21.8-48.6 48.6-48.6S170 90.9 170 117.7c0 26.9-21.7 48.6-48.6 48.6zm317.3 270.2h-74.8v-135c0-39.7-18.3-55.6-40.7-55.6-22.4 0-41.5 15.9-41.5 47.7v143h-74.8V245.8s-1.2-47.2-1.2-55.6h73.6l2.5 34c14.9-23.8 37.4-41.9 67.3-41.9 52.4 0 89.8 39.7 89.8 111.2v143h-.2z",
    fill: "#939496"
  }));
}